import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Food from '../pages/food/index';
import Restaurant from '../pages/food/restaurant/index';
import RestaurantDashboard from '../pages/food/restaurant/Manage/Dashboard';
import DishList from '../pages/food/restaurant/Manage/DishList';
import AddDish from '../pages/food/restaurant/Manage/AddDish';
import AuthWrapper from '../components/AuthWrapper';
// import EditDish from '../pages/food/restaurant/Manage/EditDish';

const FoodRoutes = () => {
  return (
    <Routes>
      <Route index element={
        <AuthWrapper>
          <Food />
        </AuthWrapper>
      } />
      <Route path="restaurant/:restaurantId" element={
        <AuthWrapper>
          <Restaurant />
        </AuthWrapper>
      } />
      <Route path="restaurant/:restaurantId/manage" element={
        <AuthWrapper>
          <RestaurantDashboard />
        </AuthWrapper>
      } />
      <Route path="restaurant/:restaurantId/manage/dishes" element={
        <AuthWrapper>
          <DishList />
        </AuthWrapper>
      } />
      <Route path="restaurant/:restaurantId/manage/dishes/add" element={
        <AuthWrapper>
          <AddDish />
        </AuthWrapper>
      } />
      {/* <Route path="restaurant/:restaurantId/manage/dishes/edit/:dishId" element={
        <AuthWrapper>
          <EditDish />
        </AuthWrapper>
      } /> */}
    </Routes>
  );
};

export default FoodRoutes;